export default {
      id: "burger-menu-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.4f7c228b.svg#burger-menu",
      toString: function () {
        return this.url;
      }
    }